/*
 * STOREFRONT - the storefront modules a Twig theme can opt in to. NOT part of app.js:
 * app.js is on every page of every tenant's theme, and a theme that still carries
 * its own copy of these would run them twice. A theme asks for this bundle in its
 * config.json:  "engine_scripts": ["storefront.js"]  (ThemeService adds it to the head).
 *
 *  - headerCart:     the cart drawer, the add-to-cart buttons
 *  - productPage:    switching the variant on the product page (data-pdp-* markup)
 *  - switch-variant: the variant values on list cards
 * They need the globals of app.js (Vue, http, Cookies, AppEvents, currency).
 */
require('./modules/headerCart.js');
require('./modules/productPage.js');
require('./basics/switch-variant.js');
